import StoreHandler from './storeHandler';

export const generateReducer = (items = {}, reducer = '') => {
	const reducers = {};

	Object.keys(items).map((item) => {
		reducers[item] = (state = items[item], action) => {
			switch (action.type) {
				//set
				case `${reducer ? `${reducer.toUpperCase()}/` : ''}${item.toUpperCase()}/SET`:
					return StoreHandler.setState(state, { ...action.payload });
				//clear
				case `${reducer ? `${reducer.toUpperCase()}/` : ''}${item.toUpperCase()}/CLEAR`:
					return StoreHandler.clearState(state, items[item], { ...action.payload });
				//custom
				case `${reducer ? `${reducer.toUpperCase()}/` : ''}${item.toUpperCase()}/CUSTOM`:
					return { ...action.payload };

				default:
					return state;
			}
		};
	});

	return reducers;
};
